import { render, staticRenderFns } from "./OwnerFormComponent.vue?vue&type=template&id=70c7f4ba"
import script from "./OwnerFormComponent.vue?vue&type=script&lang=js"
export * from "./OwnerFormComponent.vue?vue&type=script&lang=js"
import style0 from "./OwnerFormComponent.vue?vue&type=style&index=0&id=70c7f4ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports